import { render, staticRenderFns } from "./CookiePreferences.vue?vue&type=template&id=40932396"
import script from "./CookiePreferences.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookiePreferences.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40932396')) {
      api.createRecord('40932396', component.options)
    } else {
      api.reload('40932396', component.options)
    }
    module.hot.accept("./CookiePreferences.vue?vue&type=template&id=40932396", function () {
      api.rerender('40932396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/cookies/CookiePreferences.vue"
export default component.exports